export default "__VITE_ASSET__DKzcB1P8__"